import 'intersection-observer';
import React, { Component } from 'react';
import Header from './Components/Header/Header';
import Content from './Components/Content/Content';
import Login from "./Components/Login/Login";
import Cookies from "universal-cookie";
import './Fonts.css';
import './App.css';
import $ from "jquery";
import {ajax} from "./Context";
import PublicContent from "./Components/Content/PublicContent";

const COOKIES = new Cookies();
const AJAX_TYPE = '135794';

class App extends Component {
    constructor(props) {
        super(props);
        var hash = COOKIES.get('hash');
        let route = '';

        if(typeof hash === 'undefined' || hash === '') {
            hash = '';
        }
        var session = COOKIES.get('session');
        if(typeof session === 'undefined' || session === false) {
            session = false;
        }else{
            var uri = window.location.href.replace(window.location.origin + '/','');
            var routing = uri.split('/');
            if(routing.length > 0 && routing[0] !== '') {
                route = routing[0];
            }
        }

        this.state = {
            product: null,
            user:[],
            results: null,
            category:0,
            rootCategory:0,
            searchword: '',
            lastSearchword: '',
            route:route,
            icon:'log-in',
            hash:hash,
            session:session,
            file:'',
            backPath:'',
            width:0,
            height:0,
            goBack:false
        };
        this.loginUser = this.loginUser.bind(this);
        this.logoutUser = this.logoutUser.bind(this);
        this.loggedIn = this.loggedIn.bind(this);
        this.setProduct = this.setProduct.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.setRootCategory = this.setRootCategory.bind(this);
        this.setSearchword = this.setSearchword.bind(this);
        this.setResults = this.setResults.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
        this.setLastsearch = this.setLastsearch.bind(this);
        this.changeRoute = this.changeRoute.bind(this);
        this.setHash = this.setHash.bind(this);
        this.setUser = this.setUser.bind(this);
        this.setSession = this.setSession.bind(this);
        this.setFile = this.setFile.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onBackButtonEvent = this.onBackButtonEvent.bind(this);
        this.createHistoryEntry = this.createHistoryEntry.bind(this);
    }

    componentDidMount() {
        if(this.state.hash === '') {
            fetch(ajax.url + '?type=' + AJAX_TYPE + '&uhash=' + this.state.hash)
            .then(response => response.json())
            .then(data => this.setState({hash: data.hash,user:data.user}));
        }

        if(typeof this.state.user !== 'undefined' && this.state.user.length > 0) {
            this.setState( {
                icon: 'log-out'
            });
        }
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        window.onpopstate = this.onBackButtonEvent;
        window.onhashchange = function() {
            alert("hash changed!");
        };

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    loginUser() {
        if(typeof this.state.session !== 'undefined' && this.state.session === true && this.state.hash !== '') {
            COOKIES.set('hash',this.state.hash,{maxAge : 31536000});
            COOKIES.set('session',this.state.session,{maxAge : 31536000});
        }else{
            this.logoutUser();
        }
    }

    logoutUser() {
        COOKIES.remove('hash');
        COOKIES.remove('session');
        $.ajax({
            url: ajax.url + '?type=' + AJAX_TYPE,
            type: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            dataType: 'json',
            data: {
                'uhash': this.state.hash
            },
            cache: false,
            success: function (data) {
                this.setState({
                    session:false
                });
                this.setCategory(null);
                this.setProduct(null);
                this.resetSearch();
                this.changeRoute('/');
                this.setHash(data.hash);
                this.setUser(null);
            }.bind(this)
        });
    }

    loggedIn() {
        if(typeof this.state.hash === 'undefined' || this.state.hash === '' || typeof this.state.session === 'undefined' || this.state.session === false) {
            return false;
        }
        return true;
    }

    setUser(user) {
        this.setState({
            user:user
        });
    }

    setSession(session) {
        this.setState({
            session:session
        });
    }

    setProduct(product) {
        this.setState({
            product:product
        });
    }

    setCategory(category) {
        this.setState({
            category:category
        });
    }

    setRootCategory(category) {
        this.setState({
            rootCategory:category
        });
    }

    setSearchword(word) {
        this.setState({
            searchword:word
        });
    }

    setResults(results) {
        this.setState({
            results:results
        });
    }

    setLastsearch(word) {
        this.setState({
            lastSearchword:word
        });
    }

    setHash(hash) {
        this.setState({
            hash:hash
        });
    }

    setFile(file) {
        if(file !== '') {
            var link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', file);

            var meta = document.createElement('meta');
            meta.setAttribute('property','og:url');
            meta.setAttribute('content',file);

            document.head.appendChild(link);
            document.head.appendChild(meta);
        }
        this.setState({
           file:file
        });
    }

    resetSearch() {
        this.setState({
            results:null,
            searchword:'',
            lastSearchword:''
        });
    }

    changeRoute(route) {
        this.setState({
            route:route
        });
        if(this.state.goBack) {
            this.setState({goBack:false});
        }
    }

    onBackButtonEvent(e) {
        e.preventDefault();
        var history = JSON.parse(window.history.state);
        if(history) {
            this.setState({
                category:history.category,
                file:history.file,
                hash:history.hash,
                height:history.height,
                icon:history.icon,
                lastSearchword:history.lastSearchword,
                product:history.product,
                results:history.results,
                route:history.route,
                searchword:history.searchword,
                session:history.session,
                user:history.user,
                width:history.width,
                goBack:true
            });
        }
    }

    createHistoryEntry() {
        if(this.state.goBack === false) {
            window.history.pushState(JSON.stringify(this.state),this.state.route,'/');
        }else{
            window.history.replaceState(JSON.stringify(this.state),this.state.route,'/')
        }
    }

    render() {
        let c;
        let cn;
        var s = false;
        if(this.loggedIn()) {
            s = true;
            cn = 'App';
            c = <div className="wrapper">
                    <Content resetSearch={this.resetSearch} lastSearchword={this.state.lastSearchword} setFile={this.setFile} file={this.state.file} setRootCategory={this.setRootCategory}
                             setLastsearch={this.setLastsearch} setResults={this.setResults} searchword={this.state.searchword} createHistoryEntry={this.createHistoryEntry}
                             setSearchword={this.setSearchword} route={this.state.route} changeRoute={this.changeRoute} width={this.state.width} height={this.state.height}
                             setCategory={this.setCategory} searching={this.state.searching}  hash={this.state.hash} logoutUser={this.logoutUser} rootCategory={this.state.rootCategory}
                         category={this.state.category} user={this.state.user} product={this.state.product} setProduct={this.setProduct} results={this.state.results} />
                <PublicContent hash={this.state.hash} route={this.state.route} changeRoute={this.changeRoute} />
            </div>;
        }else{
            cn = 'App login-screen';
            c = <div className="login-mask">
                <Login loginUser={this.loginUser} setSession={this.setSession} logoutUser={this.logoutUser} setUser={this.setUser} hash={this.state.hash} setHash={this.setHash} loggedIn={this.loggedIn} route={this.state.route} changeRoute={this.changeRoute} />
            </div>;
        }

        return (
            <div className={cn}>
                <Header loggedIn={s} resetSearch={this.resetSearch} hash={this.state.hash} setHash={this.setHash} setUser={this.setUser}
                        logoutUser={this.logoutUser} setCategory={this.setCategory} route={this.state.route} changeRoute={this.changeRoute} />
                    {c}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js